import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/modals';
import { TModalActionPayload } from '../types/modals';

// eslint-disable-next-line import/prefer-default-export
export const setModal = createAction<TModalActionPayload>(types.SET_MODAL);
